// extracted by mini-css-extract-plugin
module.exports = {"layout":"AccordionItem_layout__n8tFT","panel":"AccordionItem_panel__ZJCbE"};